import axios from 'axios'
import {eventBus} from "@/event-bus";

export default {
	namespaced: true,
	
	state: {
		isAuthenticated: false,
		user: {
			id: null,
			email: null,
			account_manager: null, // se !== null l'utente connesso è un account manager
			cliente: null, // se !== null l'utente connesso è un cliente
			coordinatore: null, // se !== null l'utente connesso è un account manager
			created_at: null,
			updated_at: null
		},
	},

	getters: {
		isAuthenticated (state) {
			return state.isAuthenticated
		},
		user (state) {
			return state.user
		},
		isAccountManager(state) {
			return state.user.account_manager !== null;
		},
		isCliente(state) {
			return state.user.cliente !== null;
		},
		isAzienda(state) {
			return state.user?.cliente?.tipologia == 'Azienda';
		},
		isConsulente(state) {
			return state.user?.cliente?.tipologia == 'Consulente';
		},
		isAssociazioneDiCategoria(state) {
			return state.user?.cliente?.tipologia == 'Associazione di categoria';
		},
		isCoordinatore(state) {
			return state.user.coordinatore !== null;
		},
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_AUTHENTICATED (state, value) {
			state.isAuthenticated = value
		},
		SET_USER (state, value) {
			state.user = value
		},
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		async login ({ dispatch }, credentials) { // con { dispatch } viene applicata la destrutturazione degli argomenti
			await axios.get('/sanctum/csrf-cookie');
			await axios.post('/login', credentials)
			.then(response => {
			
			})
			.catch(error => {
				eventBus.$emit('send-login-error', error.response.data.message);
			})

			return dispatch('me'); // con la destrutturazione non è necessario scrivere context.dispatch
		},

		async logout ({ dispatch }) {
			await axios.post('/logout');
			// return dispatch('me');
			await dispatch('resetMe');
		},

		me ({ commit, dispatch }) {
			return axios.get('/api/utente')
				.then(async (response) => {
					commit('SET_AUTHENTICATED', true); // stessa cosa qua, non devo scrivere "context.commit
					commit('SET_USER', response.data);
					// if (getters.isAccountManager) {
					// 	dispatch('shared/ottieniImpostazioniAm', null, {root: true})
					// }
					await dispatch('shared/globalVariables', null, {root: true});
					await dispatch('fasi/getFasiWithStati', null, { root: true });
					
				})
				// .catch(error => {
				// 	commit('SET_AUTHENTICATED', false);
				// 	commit('SET_USER', {
				// 		email: null
				// 	});
				// 	commit('fasi/SET_FASI_WITH_STATI', [], { root: true })
				// 	dispatch('shared/unsetGlobalVariables', null, { root: true });
				// })
		},
		
		resetMe({ commit, dispatch }) {
			commit('SET_AUTHENTICATED', false);
			commit('SET_USER', {
				email: null
			});
			commit('fasi/SET_FASI_WITH_STATI', [], { root: true })
			dispatch('shared/unsetGlobalVariables', null, { root: true });
		}
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }